import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EventService } from 'app/services/event.service';
import { AppPageEnum } from '../enums';
import { UserService } from 'app/services';
import { BaseComponent } from './base-component/base-component.component';

@Component({
    selector: 'app-badges',
    template: `<div class="px-2 py-0.5 text-xs font-medium rounded-full"
                [ngClass]="{
                  'bg-green-100 text-green-700': type == 'success',
                  'bg-red-100 text-red-700': type == 'error',
                  'bg-amber-100 text-amber-700': type == 'warning',
                  'bg-primary-100 text-primary-700': type == 'info',
                  'bg-gray-100 text-gray-600': type == 'default'
                }"
                [attr.id]="toolTipName"
                (mouseenter)="showTooltip($event, toolTipName)">
        {{label}}
        </div>`,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgetsComponent extends BaseComponent implements OnInit {
  @Input() label!: string;
  @Input() type!: string;
  @Input() isRounded!: boolean;
  @Input() toolTipPage!: AppPageEnum;

  constructor(eventService: EventService, private userService: UserService) {
    super(eventService, null);
  }

  ngOnInit(): void {
    this.page = this.toolTipPage;
  }
}
